export default "/fonts/vendor/fontsource-roboto/files/roboto-latin-ext-400-normal.woff2?dcc07bcfcd475f34f20b2c1265bd1265";